export const routes = [
    {
        path: '/',
        text: 'Homepage',
    },
    {
        path: '/great-telepresence',
        text: ' Form',
    },
    { path: '/great-telepresence/review', text: 'Review', allowedRoles: ['admin'] },
];
